import api from "./api";

function loadScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

export async function openPaymentModal({ orderData, onSuccess, onError, onDismiss }) {
  const loaded = await loadScript();
  if (!loaded) {
    onError?.("Failed to load payment gateway. Please try again.");
    return;
  }

  const options = {
    key: orderData.key_id,
    amount: orderData.amount,
    currency: orderData.currency,
    name: "Playaway Club",
    description: orderData.pack_title,
    image: "/logo.jpg",
    order_id: orderData.razorpay_order_id,
    prefill: { email: orderData.buyer_email || "" },
    handler: async (response) => {
      try {
        const { data } = await api.post("/orders/verify", {
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        });
        onSuccess?.(data);
      } catch {
        onError?.("Payment received but verification failed. Contact us on Instagram.");
      }
    },
    theme: { color: "#FF6B57" },
    config: {
      display: {
        blocks: {
          upi: { name: "Pay via UPI", instruments: [{ method: "upi" }] },
          card: { name: "Pay via Card", instruments: [{ method: "card" }] },
          netbanking: { name: "Pay via Netbanking", instruments: [{ method: "netbanking" }] },
          wallet: { name: "Pay via Wallet", instruments: [{ method: "wallet" }] },
        },
        sequence: ["block.upi", "block.card", "block.netbanking", "block.wallet"],
        preferences: { show_default_blocks: false },
      },
    },
    modal: { ondismiss: () => onDismiss?.() },
  };

  const rzp = new window.Razorpay(options);
  rzp.on("payment.failed", (resp) => {
    onError?.(resp.error?.description || "Payment failed. Please try again.");
  });
  rzp.open();
}
